<template>
  <el-dialog
    title="新增机器"
    :visible="true"
    :before-close="closeForm"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="45%"
  >
    <el-form
      :model="ruleForm"
      :rules="rules"
      :inline="true"
      ref="ruleForm"
      label-width="120px"
      class="demo-ruleForm"
    >
      <el-form-item label="机器ID" prop="machineid">
        <el-input v-model.trim="ruleForm.machineid"></el-input>
      </el-form-item>
      <el-form-item label="IMEI" prop="machineImei">
        <el-input v-model.trim="ruleForm.machineImei"></el-input>
      </el-form-item>
      <el-form-item label="机器类型" prop="machineType">
        <el-select
          v-model="ruleForm.machineType"
          placeholder="请选择"
          @change="handleChangeMachineType"
        >
          <el-option
            v-for="(item, index) in $AllMachineModelInfoList"
            :key="index"
            :label="item.machineTypeCnName"
            :value="item.machineTypeCode"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="机器型号" prop="machineModel">
        <el-select
          v-model="ruleForm.machineModel"
          placeholder="请选择"
          @change="handleChangeMachineModel"
        >
          <template v-if="ruleForm.machineType">
            <el-option
              v-for="(item, index) in $AllMachineModelInfoList.find(
                ele => ele.machineTypeCode === ruleForm.machineType
              ).machineSpec"
              :key="index"
              :label="item.machineModel + '【' + item.machineModelName + '】'"
              :value="item.machineModel"
            >
            </el-option>
          </template>
        </el-select>
      </el-form-item>
      <el-form-item label="机器名称" prop="machineName">
        <el-input
          v-model.trim="ruleForm.machineName"
          :readonly="true"
        ></el-input>
      </el-form-item>
      <el-form-item label="序列号" prop="machineSn">
        <el-input v-model="ruleForm.machineSn" placeholder="输入序列号">
        </el-input>
      </el-form-item>
      <el-form-item label="店内编号" prop="machineCodeInShop">
        <el-input v-model.trim="ruleForm.machineCodeInShop"></el-input>
      </el-form-item>
      <el-form-item label="是否可用" prop="machineEnable">
        <el-select v-model="ruleForm.machineEnable" placeholder="请选择">
          <el-option label="是" :value="true"></el-option>
          <el-option label="否" :value="false"></el-option>
        </el-select>
      </el-form-item>
      <!-- <el-form-item label="机器维护人员" prop="machineOperator">
        <el-input v-model.trim="ruleForm.machineOperator"></el-input>
      </el-form-item> -->
      <el-form-item label="可用开始时间" prop="machineStartTime">
        <!-- <el-input v-model.trim="ruleForm.machineStartTime"></el-input> -->
        <el-time-select
          placeholder="可用开始时间"
          v-model="ruleForm.machineStartTime"
          :picker-options="{
            start: '00:00',
            step: '00:30',
            end: '24:00'
          }"
        >
        </el-time-select>
      </el-form-item>
      <el-form-item label="可用结束时间" prop="machineStopTime">
        <!-- <el-input v-model.trim="ruleForm.machineStopTime"></el-input> -->
        <el-time-select
          placeholder="结束时间"
          v-model="ruleForm.machineStopTime"
          :picker-options="{
            start: '00:00',
            step: '00:30',
            end: '24:00'
          }"
        >
        </el-time-select>
      </el-form-item>

      <agentVendorShop @select="selectHandler" />

      <el-form-item label="备注" prop="remark">
        <el-input v-model="ruleForm.remark" placeholder="备注"> </el-input>
      </el-form-item>

      <div class="align-center">
        <el-button type="primary" @click="submitForm(true)">确定</el-button>
        <el-button type="primary" @click="submitForm(false)"
          >连续添加</el-button
        >
        <el-button @click="closeForm()">取消</el-button>
      </div>
    </el-form>
  </el-dialog>
</template>

<script>
import agentVendorShop from "@/components/layout/agentVendorShop";
import enumObject from "../../../plugins/enum";
//import { mapGetters } from "vuex";
export default {
  components: {
    agentVendorShop
  },
  data() {
    return {
      ruleForm: {
        machineid: "",
        machineImei: "",
        machineType: "",
        machineModel: "",
        machineManufactureDate: "",
        machineName: "",

        agentid: "",
        agentName: "",

        vendorid: "",
        vendorName: "",
        machineCity: "",
        machineInShopid: "",
        shopName: "",
        machineCodeInShop: "",
        machineStatus: 0,
        machineEnable: true,
        machineSn: "",
        machineOperator: "",
        machineStartTime: "00:00",
        machineStopTime: "00:00",
        remark: ""
      },
      rules: {
        machineid: [{ required: true, message: "请输入机器ID" }],
        machineImei: [{ required: true, message: "请输入机器IMEI" }],
        machineType: [{ required: true, message: "请输入机器类型" }],
        machineModel: [{ required: true, message: "请输入机器型号" }],
        machineManufactureDate: [
          { required: true, message: "请输入机器生产日期" }
        ],
        machineName: [{ required: true, message: "请输入机器名称" }],
        agentid: [{ required: true, message: "请输入总代" }],
        vendorid: [{ required: true, message: "请输入加盟商" }],
        machineCity: [{ required: true, message: "请输入机器所在城市" }],
        machineStartTime: [
          { required: true, message: "请输入可用开始时间，格式00:00" }
        ],
        machineStopTime: [
          { required: true, message: "请输入可用结束时间，格式00:00" }
        ],
        machineInShopid: [{ required: true, message: "请输入门店" }],
        machineCodeInShop: [{ required: true, message: "请输入店内编号" }],
        //machineStatus: [{ required: true, message: "请输入机器状态" }],
        machineEnable: [{ required: true, message: "请输入机器是否可用" }]
        //machineOperator: [{ required: true, message: "请输入机器操作人员" }]
      },
      // vendorsList: [],
      // shopList: [],
      vendorListForPrompt: [],
      shopListForPrompt: []
    };
  },
  methods: {
    selectHandler(x) {
      console.log("selectHandler", x);
      this.ruleForm.agentid = x.selectedAgent.agentid;
      this.ruleForm.vendorid = x.selectedVendor.vendorid;
      this.ruleForm.machineInShopid = x.selectedShop.shopid;
    },
    handleChangeMachineType() {
      this.ruleForm.machineModel = this.ruleForm.machineName = "";
    },
    handleChangeMachineModel() {
      let machineName = "";
      this.$AllMachineModelInfoList.forEach(ele => {
        ele.machineSpec.forEach(ele1 => {
          if (ele1.machineModel === this.ruleForm.machineModel) {
            machineName = ele1.machineModelName;
            return;
          }
        });
      });
      this.ruleForm.machineName = machineName;
    },

    submitForm(closeDialog) {
      this.$refs["ruleForm"].validate(valid => {
        if (valid) {
          let queryModel = {
            machineid: this.ruleForm.machineid,
            machineType: this.ruleForm.machineType,
            machineModel: this.ruleForm.machineModel,
            machineImei: this.ruleForm.machineImei,
            // machineManufactureDate: this.$ToDateTimeString(
            //   this.ruleForm.machineManufactureDate
            // ),
            machineName: this.ruleForm.machineName,
            vendorid: this.ruleForm.vendorid,
            machineCity: this.ruleForm.machineCity,
            machineInShopid: this.ruleForm.machineInShopid,
            machineCodeInShop: this.ruleForm.machineCodeInShop,
            machineStatus: this.ruleForm.machineStatus,
            machineEnable: this.ruleForm.machineEnable,
            machineOperator: this.ruleForm.machineOperator,
            machineStartTime: this.ruleForm.machineStartTime,
            machineStopTime: this.ruleForm.machineStopTime,
            remark: this.ruleForm.remark,
            machineSn: this.ruleForm.machineSn
          };
          this.$axios(this.$urlMapping["新增机器"], {
            data: queryModel
            // eslint-disable-next-line no-unused-vars
          }).then(result => {
            this.$notifySuccess();
            if (closeDialog) {
              this.$emit("closeForm");
              this.$emit("handleUpdate");
            } else {
              this.$refs["ruleForm"].resetFields();
              this.$emit("handleUpdate");
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    closeForm() {
      this.$emit("closeForm");
    }
  },
  computed: {
    CITY_ENUM() {
      return enumObject.CITY_ENUM.filter(ele => ele.value !== "");
    },
    MACHINE_STATUS_ENUM() {
      return enumObject.MACHINE_STATUS_ENUM.filter(ele => ele.value !== "");
    }
  },

  async mounted() {}
};
</script>

<style lang="less" scoped>
/deep/ .el-select {
  width: 202px;
}

/deep/ .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 202px;
}
</style>
